import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenuBillsFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.1016 1.00098C11.1512 1.00098 11.2008 1.00514 11.25 1.00879V8.00098C11.25 9.51976 12.4812 10.751 14 10.751H19.999C19.999 10.7544 20 10.7583 20 10.7617V21.001C20 22.1055 19.1046 23.001 18 23.001H6C4.89543 23.001 4 22.1055 4 21.001V3.00098C4 1.89641 4.89543 1.00098 6 1.00098H11.1016ZM19.334 9.25098H14C13.3096 9.25098 12.75 8.69133 12.75 8.00098V1.84375L19.334 9.25098Z",
		fill: "#311123"
	})
});
export default SvgMenuBillsFilled;
